define(
    'views/admin_options.view',[
        'loader',
        'config',
        'helper',
        'sandbox'

    ],
    function(Loader, Config, Helper, Sandbox)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdminOptionsView = Loader.Backbone.View.extend(
            {

                routes: {
                    "/admin_options.php$": "lockCategoryChange"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });

                },

                render: function()
                {
                    return this;
                },

                lockCategoryChange: function()
                {
                    // Оказывается уже реализовано средствами сервиса :)
                    /*var locked = [31];
                    var categoryId = this.model.get('forum').get('boardCat');

                    if (locked.indexOf(categoryId) != -1) {
                        var container = $('select[name*=board_catalog]').parent();
                        container.html('Эротика');
                    }*/
                }
            });

        return {
            initialize: function(model)
            {
                return new AdminOptionsView({
                    el: $("#pun-admain1"),
                    model: model
                })
            }
        }
    }
);
